import Cookies from "js-cookie";


export type LiteUserInfo = {
    id: number;
    full_name: string;
    profile_picture: string;
    phone_number: string;
    member_type:number
  };
  
  export type AuthTicketType = {
    t: number;
    k: string;
  };

export const jsonSafeGet = <T>(jsonString : any, defaultData = {}): T => {
    let output = defaultData as T;
    try {
        output = JSON.parse(jsonString);
    } catch (e) {
        // do nothing.
    }
    return output;
    };

type CookiesDataTypes = {
    userInfo : LiteUserInfo
    tgtTimestamp : any
    tgtTicket : any
    ecountry :string
    source:string
    device_uuid:string
    NEXT_LOCALE:string
    VIEWED_LISTING_COOKIE:string
    audience : string
    cityId : string
}

export const isDeviceMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");
}

export const getCookies = () => {
    const data : CookiesDataTypes  =  {
        userInfo: jsonSafeGet<LiteUserInfo>(Cookies.get('userInfo')),
        tgtTimestamp: jsonSafeGet<AuthTicketType>(Cookies.get('auth')).t || Cookies.get('tgt_timestamp'),
        tgtTicket: jsonSafeGet<AuthTicketType>(Cookies.get('auth')).k || Cookies.get('tgt_ticket'),
        ecountry: Cookies.get('ecountry') ?? 'jo',
        source : Cookies.get('source') || Cookies.get('source') || (isDeviceMobile() ? 'mobile' : 'desktop'),
        device_uuid: Cookies.get('device_uuid') ?? '',
        NEXT_LOCALE:Cookies.get('NEXT_LOCALE') ?? 'ar',
        VIEWED_LISTING_COOKIE:Cookies.get('recentlyViewed') ?? 'recentlyViewed',
        audience:  Cookies.get('source') || (isDeviceMobile() ? 'mobile' : 'desktop'),
        cityId : Cookies.get('cityId') || ''
    }
    return data;
  }

 export const defaultOptions = {
    expires: process.env.REACT_APP_DEFAULT_COOKIES_EXPIRED_IN_MINUTES,
    path: "/",
    ...(typeof window !== "undefined"
      ? window.location.hostname.includes("localhost")
        ? { domain: window.location.hostname }
        : {
            domain:
              "." +
              window.location.hostname.split(".").reverse()[1] +
              "." +
              window.location.hostname.split(".").reverse()[0],
          }
      : {}),
  };
  
export const setCookie = (name : string , value : string, options : any)  => {
    // Default values for options:
    let { expires = "" , path = "/", domain = "" } = options;
  
    // If expires is a number, convert it to minutes and create a Date object:
    if (typeof expires === "number") {
      const minutes = expires;
      const now = new Date();
      now.setTime(now.getTime() + minutes * 60 * 1000);
      expires = now;
    }
  
    // Construct the cookie string:
    let cookieString = `${name}=${value}`;
  
    if (expires instanceof Date) {
      cookieString += `;expires=${expires.toUTCString()}`;
    }
  
    if (path) {
      cookieString += `;path=${path}`;
    }
  
    if (domain) {
      cookieString += `;domain=${domain}`;
    }
  
    // Set the cookie:
    document.cookie = cookieString;
  }
  
  
  const generateOpenSooqRedirectUrlMYOS = (url ?: string,country ?: string,lang ?: string) => {
    let redirectTo = url?.replace("{country}", country ?? '').replace("{lang}", lang ?? '');
    return redirectTo;
  }

  const generateOpenSooqRedirectUrlAddPost = (url ?: string,country ?: string,lang ?: string) => {
    let redirectTo = url?.replace("XX", country ?? '') + '/' + lang ?? ''
    return redirectTo;
  }

  // this function is used to handle the deep links for MYOS Only (do not use it for the up-selling)
  export const deepLinkHandlerMYOS = (deepLink: string) => {
    const requestUri = deepLink.replace("xx", getCookies().ecountry);
    const deepLinkBase =  generateOpenSooqRedirectUrlMYOS(process.env.REACT_APP_OPENSOOQ_BASE ?? '',getCookies().ecountry, getCookies().NEXT_LOCALE) + '/';
    const url = `${deepLinkBase}site/dl?requestUri=${requestUri}`;
    window.open(url,'_blank');
  }

  // this function is used to handle the deep links for Add Post Only (do not use it for MYOS benefits)
  export const deepLinkHandlerAddPost = (deepLink: string) => {
    const requestUri = deepLink.replace("XX", getCookies().ecountry);
    const deepLinkBase =  generateOpenSooqRedirectUrlAddPost(process.env.REACT_APP_JO_SOOQ_URL ?? '',getCookies().ecountry, getCookies().NEXT_LOCALE) + '/';
    const url = `${deepLinkBase}site/dl?requestUri=${requestUri}`;
    window.open(url,'_blank');
  }


